<template>
  <div class="img-upload-wrap row">
    <div class="img-block img_item col-md-4" v-for="(item, i) of images" :key="i">
      <img class="img-detail w-100 mb-2 image-select" :src="item?.link" alt="image" />
      <div v-if="isPostImg" class="delete_wrap"></div>
      <img
        v-if="isPostImg"
        class="icon_delete"
        src="@/assets/images/delete.svg"
      />
    </div>
    <div
      class="img-block upload_wrap"
      v-if="listImages.length < maxImg && isPostImg"
    >
      <!-- <img class="img-detail" :src="item"/> -->
      <img src="@/assets/images/upload.svg" />
      <div class="text-noted">あと6枚まで登録可能</div>
      <input
        type="file"
        ref="fileInput"
        style="display: none"
        @change="handleUpload"
      />
      <button type="button" @click="$refs.fileInput.click()">pick file</button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  maxImg: {
    type: Number,
    default: 6,
  },
  isPostImg: {
    type: Boolean,
    default: true,
  },
  images: {
    type: Array,
    default: () => [''],
  },
});

const listImages = ref([
  'https://sbshouse.vn/wp-content/uploads/2021/05/bi%E1%BB%87t-th%E1%BB%B1-%C4%91%E1%BA%B9p-hi%E1%BB%87n-%C4%91%E1%BA%A1i-8-1024x731.jpg',
  'https://sbshouse.vn/wp-content/uploads/2021/05/bi%E1%BB%87t-th%E1%BB%B1-%C4%91%E1%BA%B9p-hi%E1%BB%87n-%C4%91%E1%BA%A1i-8-1024x731.jpg',
  'https://sbshouse.vn/wp-content/uploads/2021/05/bi%E1%BB%87t-th%E1%BB%B1-%C4%91%E1%BA%B9p-hi%E1%BB%87n-%C4%91%E1%BA%A1i-8-1024x731.jpg',
  'https://sbshouse.vn/wp-content/uploads/2021/05/bi%E1%BB%87t-th%E1%BB%B1-%C4%91%E1%BA%B9p-hi%E1%BB%87n-%C4%91%E1%BA%A1i-8-1024x731.jpg',
]);

const handleUpload = (event) => {
  listImages.value.push(event.target.files[0]);
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/upload/img.scss';
</style>
